/**
 * Ersetzt Platzhalter in E-Mail-Vorlagen anhand eines Leads.
 * Unterstützt {{name}} / {name}, {{company}} / {company}, {{vorname}}, {{firma}}, …
 */
export function fillEmailTemplate(text, lead, extras = {}) {
  if (!text) return '';
  const l = lead || {};
  const vorname = (l.firstName || l.name?.split(' ')?.[0] || '').trim();
  const nachname = (l.lastName || l.name?.split(' ')?.slice(1)?.join(' ') || '').trim();
  const name = (l.name || [vorname, nachname].filter(Boolean).join(' ') || '').trim();
  const company = (l.company || '').trim();
  const city = (l.city || '').trim();
  const domain = (l.domain || '').trim();
  const tel = (l.tel || '').trim();
  const email = (l.email || '').trim();
  const datum = extras.datum != null ? String(extras.datum) : '';
  const uhrzeit = extras.uhrzeit != null ? String(extras.uhrzeit) : '';

  const pairs = [
    ['{{name}}', name],
    ['{name}', name],
    ['{{company}}', company],
    ['{company}', company],
    ['{{vorname}}', vorname],
    ['{vorname}', vorname],
    ['{{nachname}}', nachname],
    ['{nachname}', nachname],
    ['{{firma}}', company],
    ['{firma}', company],
    ['{{stadt}}', city],
    ['{stadt}', city],
    ['{{domain}}', domain],
    ['{domain}', domain],
    ['{{tel}}', tel],
    ['{tel}', tel],
    ['{{email}}', email],
    ['{email}', email],
    ['{{datum}}', datum],
    ['{datum}', datum],
    ['{{uhrzeit}}', uhrzeit],
    ['{uhrzeit}', uhrzeit],
  ];

  let out = String(text);
  for (const [token, value] of pairs) {
    if (!token) continue;
    out = out.split(token).join(value);
  }
  return out;
}

/** Für Hilfe-Boxen: einzeilige Platzhalter zum Kopieren */
export const EMAIL_PLACEHOLDER_CHIPS = [
  '{name}',
  '{company}',
  '{{vorname}}',
  '{{nachname}}',
  '{{firma}}',
  '{{stadt}}',
  '{{datum}}',
  '{{uhrzeit}}',
];
